<template>
	<errorContainer :error="error" :warning="warning">
		<custom-loading-planning :loading="isLoading" :label="FormMSG(40, 'Prepare data of timesheet entry for crew')" />
		<transition ref="green-planning-item" name="slide">
			<div class="form">
				<b-row v-if="Timesheets" class="animated fadeIn">
					<b-col cols="12" xl="12">
						<div class="clearfix mb-2">
							<b-row>
								<b-col>
									<h1 :class="[`${!$screen.sm ? 'main-page-title' : ''}`, { 'is-pwa': $isPwa() }]">
										{{ FormMSG(77, 'Timesheets - Entry for crew') }}
									</h1>
								</b-col>
								<b-col v-if="groupActionCellTimeCards !== planningView" md="auto">
									<b-button class="btn btn-success pull-right block-sm" @click="showModal()">
										{{ FormMSG(3, 'Add to timesheet') }}
									</b-button>
								</b-col>
							</b-row>
							<b-row>
								<time-card-for-crew-modal
									:edit-data="editData"
									:is-open="Open"
									:is-action-crud="isActionCrud"
									:external-dates="planningToSend"
									:screen-used-the-form="`entry-for-crew`"
									:use-form-in-modal="useFormInModal"
									@add:Submitted="handleRefreshData"
									@closeModal="closeModal"
								/>
							</b-row>
						</div>
						<b-row>
							<b-col class="hide-on-tablet" cols="12" xl="12">
								<b-card no-body>
									<b-tabs v-model="currentExpenseTab" card>
										<b-tab :title="FormMSG(79, 'Time cards')" @click="setTabAction(timecards_One)">
											<b-card-text>
												<div id="header-context">
													<header-timesheets
														:id="timecards_One"
														:set-filter="(item) => setFilter(item)"
														:filter="filter"
														:on-search="onSearch"
														:select-date="allDataTimeCards"
														:form-changed="(date, idTable) => formChanged(date, idTable)"
														:form-changed-planning-view="(date, idTable) => formChangedPlanningView(date, idTable)"
														:group-by-filter="groupActionCellTimeCards"
														:data-planning-select="dataPlanningSelect"
														:show-modal="showModal"
														:is-navigate-init-date="isNavigateInitDate"
														:data-global="TimeCards"
														@month:Selected="handleSelectedFormFilter"
														@day:Selected="handleSelectedDay"
														@handleSelectDepartementChange="handleSelectDepartementChange"
														@setIsNavigateInitDate="setIsNavigateInitDate"
														@resetDataAfterAddUpdate="resetDataAfterAddUpdate"
														@refersh-on-delete-not-submitted-all="handleRefreshData"
													/>
												</div>
												<div v-if="miniSpinnerLoadingTimeCards" class="clearfix mb-0">
													<div class="text-center">
														<div>
															<b-spinner variant="primary" label="Text Centered" />
														</div>
														<div>{{ FormMSG(78, 'Prepare All data') }}</div>
													</div>
												</div>
												<div v-else>
													<div v-if="groupActionCellTimeCards === planningView">
														<planning-view-tables
															:id="timecards_One"
															ref="planning-view-table"
															:select-date="allDataTimesheets"
															:hover="hover"
															:currentpage="currentPage"
															:perpage="perPage"
															:hv="hv"
															:tsfields="fieldsTimeCardsPlanning"
															:timesheets="TimeCards"
															:date-default-select="DateDefaultSelect"
															:is-active-busy="isActiveBusy"
															:open="Open"
															:is-persist-data-planning="isPersistDataPlanning"
															:totals-planning-ts-days="totalsPlanningTsDays"
															@setDataSizeModalPlanning="setDataSizeModalPlanning"
															@sendDataModalPlanning="sendDataModalPlanning"
															@showModalPlanningContextUpdate="showModalPlanningContextUpdate"
															@changeDateDefaultSelect="changeDateDefaultSelect"
															@getDataFromPagePlanning="getDataFromPagePlanning"
															@validateTsDays="validateTsDays"
															@deleteItemPlanning="deleteItemPlanning"
															@sendForValidationPlanning="sendForValidationPlanning"
															@handleRefreshReject="handleRefreshReject"
														/>
														<b-modal
															v-model="successModal"
															header-class="header-class-modal-doc-package"
															:title="FormMSG(17, 'Success')"
															class="modal-success"
															ok-variant="success"
															ok-only
															@ok="successModal = false"
														>
															{{ FormMSG(18, 'The timesheet has been validated!') }}
														</b-modal>
													</div>
													<div v-else-if="groupActionCellTimeCards === groupByDate">
														<timesheets-per-date-view
															:id="timecards_One"
															:group-by-filter="groupActionCellTimeCards"
															:hover="hover"
															:currentpage="currentPage"
															:perpage="perPage"
															:hv="hv"
															:time-cards="TimeCards"
															:tsfields="fieldsTimeCards"
															:delete-action="(item) => deleteAction(item, timecards_One)"
															:total-all-page-records="totalAllPageRecords"
															:is-action-crud="isActionCrud"
															@refreshRequested="handleRefreshData"
															@changePageSelectLimit="changePageSelectLimit"
															@handleNextPerDate="handleNextPerDate"
															@handlePreviousPerDate="handlePreviousPerDate"
															@refreshDataItemPerDate="refreshDataItemPerDate"
														/>
													</div>
													<div v-else>
														<div
															v-if="TimeCards.length === 0"
															class="d-flex flex-row justify-content-center align-items-center border"
															style="height: 40px"
														>
															{{ FormMSG(91, 'No data') }}
														</div>
														<div v-else>
															<div
																v-for="item in TimeCards"
																:key="generateSecureId(`${item.id + Math.random()}`)"
																class="animated fadeIn"
															>
																<timesheets-efc-tables
																	:id="timecards_One"
																	:hover="hover"
																	:timesheets="item.data"
																	:tsfields="fieldsTimeCards"
																	:currentpage="currentPage"
																	:perpage="perPage"
																	:hv="hv"
																	:i="generateSecureId(item.id + item.date + item.fullName + item.departmentName)"
																	:group-by-filter="groupActionCellTimeCards"
																	:delete-action="(item, idTable) => deleteAction(item, idTable)"
																	:hide-modal="hideModal"
																	@add:Submitted="handleRefreshData"
																/>
															</div>
														</div>
													</div>
												</div>
											</b-card-text>
										</b-tab>
										<b-tab :title="FormMSG(80, 'Timesheets')" @click="setTabAction(timesheets_Two)">
											<b-card-text>
												<header-timesheets
													:id="timesheets_Two"
													:set-filter="(item) => setFilter(item)"
													:use-component="true"
													:filter="filter"
													:select-date="allDataTimesheets"
													:on-search="onSearch"
													:form-changed="(date, idTable) => formChanged(date, idTable)"
													:group-by-filter="groupActionCellTimesheets"
													:is-navigate-init-date="isNavigateInitDate"
													@month:Selected="handleSelectedFormFilter"
													@setIsNavigateInitDate="setIsNavigateInitDate"
												/>
												<div v-if="miniSpinnerLoadingTimeSheet" class="clearfix mb-0">
													<div class="text-center">
														<div>
															<b-spinner variant="primary" label="Text Centered" />
														</div>
														<div>{{ FormMSG(78, 'Prepare All data') }}</div>
													</div>
												</div>
												<div v-else>
													<div
														v-if="Timesheets.length === 0"
														class="d-flex flex-row justify-content-center align-items-center border"
														style="height: 40px"
													>
														{{ FormMSG(91, 'No data') }}
													</div>
													<div v-else>
														<div
															v-for="item in Timesheets"
															:key="generateSecureId(`${item.id + Math.random()}`)"
															class="animated fadeIn"
														>
															<timesheets-efc-tables
																:id="timesheets_Two"
																is-timesheet
																use-component
																:hover="hover"
																:timesheets="item.data"
																:tsfields="fieldsTimesheets"
																:currentpage="currentPage"
																:perpage="perPage"
																:hv="hv"
																:i="generateSecureId(item.id + item.date + item.fullName + item.departmentName)"
																:group-by-filter="groupActionCellTimesheets"
																:delete-action="(item, idTable) => deleteAction(item, idTable)"
																:hide-modal="hideModal"
																@add:Submitted="handleRefreshData"
															/>
														</div>
													</div>
												</div>
											</b-card-text>
										</b-tab>
									</b-tabs>
								</b-card>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>
		</transition>
	</errorContainer>
</template>

<script>
import { store } from '@/store';
import PlanningViewTables from '@/components/EntryForCrew/Timesheets/TimesheetsEfcTables/PlanningViewTables.vue';
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import TimeCardForCrewModal from '../../timesheet/TimeCardForCrewModal.vue';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import moment from 'moment';
import HeaderTimesheets from '@/components/EntryForCrew/Timesheets/HeaderTimesheets/HeaderTimesheets';
import TimesheetsEfcTables from '@/components/EntryForCrew/Timesheets/TimesheetsEfcTables/TimesheetsEfcTables';
import TimesheetsPerDateView from './TimesheetsPerDateView.vue';
import {
	getProjectUsersTsDaysPlanning,
	validateTsDays,
	getProjectOnlyUserTsDay,
	getProjectOnlyUserTimesheets,
	deleteTimeCardsTsDay
} from '@/cruds/timesheets-efc.crud';
import { FILTER_STRING_TIME_SHEET, NAME_CARDS_TIMESHEET_EFC, ACTION_EFC_TIMESHEET } from '@/utils/utils';
import CustomLoadingPlanning from '@/components/Plannings/Filter/CustomLoadingPlanning';
import { mapActions } from 'vuex';
import { rendCurrency } from '~helpers';
import { GetEncodingValidation } from '@/cruds/users.crud';
import { getDepartments } from '@/cruds/department.crud';
import { submitSelectedTimesheet } from '@/cruds/timesheet.crud';
import { generateSecureId } from '@/shared/utils';
export default {
	name: 'TimesheetsEntryCrew',
	components: {
		TimesheetsPerDateView,
		HeaderTimesheets,
		TimesheetsEfcTables,
		CustomLoadingPlanning,
		TimeCardForCrewModal,
		PlanningViewTables
	},
	mixins: [languageMessages, isSingleProjectMixin, globalMixin],
	props: {
		caption1: {
			type: String,
			default: 'My Timesheets'
		},
		hover: {
			type: Boolean,
			default: true
		},
		striped: {
			type: Boolean,
			default: true
		},
		bordered: {
			type: Boolean,
			default: true
		},
		small: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		}
	},
	data: () => {
		const { groupByDate, groupByDateOnly, groupByPerson, groupByStatus, planningView } = FILTER_STRING_TIME_SHEET;
		const { timecards_One, timesheets_Two } = NAME_CARDS_TIMESHEET_EFC;
		const { addData, updateData, deleteData } = ACTION_EFC_TIMESHEET;
		return {
			isActiveBusy: false,
			hv: 'dark',
			Validated: 0,
			error: {},
			TimeCards: [],
			dataUserPlanning: [],
			DateTimeCards: [],
			Timesheets: [],
			currentPage: 1,
			perPage: 0,
			warning: '',
			successModal: false,
			isLoading: false,
			filter: '',
			timecards_One,
			timesheets_Two,
			configAccordion: {
				show: {
					isVisible: false
				}
			},
			Open: false,
			curTs: {
				id: 0,
				strDate: '',
				endDate: '',
				hours: '',
				minutes: '',
				hoursOvertime: '',
				minutesOvertime: '',
				hoursOvertime1: '',
				minutesOvertime1: '',
				hoursOvertime2: '',
				minutesOvertime2: '',
				hoursTransportTimePaid: '',
				minutesTransportTimePaid: '',
				hoursNight: '',
				minutesNight: '',
				hoursTooEarly: '',
				minutesTooEarly: '',
				salary: 0,
				kgCoTwo: 0,
				validated: 0,
				validatedStatus: 'Not Submited'
			},
			TabAction: timecards_One,
			groupActionCellTimeCards: '',
			groupActionCellTimesheets: '',
			groupByActionValue: null,
			groupByPerson,
			groupByDate,
			groupByDateOnly,
			groupByStatus,
			planningView,
			filterByPerson: false,
			filterByStatus: false,
			filterByDate: false,
			filterPlanning: true,
			allDataTimeCards: [],
			allDataTimesheets: [],
			showGridDetails: false,
			editData: {},
			addData,
			updateData,
			deleteData,
			isActionCrud: '',
			timesheetActiveTab: 0,
			expenseStatusDefault: 0,
			miniSpinnerLoadingTimeCards: false,
			miniSpinnerLoadingTimeSheet: false,
			generateSecureId,
			DateDefaultSelect: {
				value: moment(Date.now()).format('MM/YYYY'),
				text: moment(Date.now()).format('MMMM YYYY')
			},
			isRefresh: false,
			headerTabPlanning: [],
			rendCurrency,
			dataPlanningSelect: [],
			isNavigateInitDate: false,
			planningToSend: [],
			recordOffSet: 0,
			recordLimit: 20,
			recordLimitPerDate: 10,
			recordOffSetPerDate: 0,
			allDepartment: [],
			departmentAutorization: [],
			totalAllPageRecords: 0,
			isPersistDataPlanning: false,
			valueToSearch: null,
			departmentPersist: {
				id: null,
				value: null,
				message: null
			},
			useFormInModal: true,
			fromMount: true,
			totalsPlanningTsDays: 0
		};
	},
	computed: {
		canSeeSalary() {
			return !store.getCurrentProjectConfig().hideSalaryInfo && !store.hideSalaryInfo();
		},
		fieldsTimeCards() {
			let fields = [
				{
					key: 'select',
					label: this.FormMSG(90, 'Select')
				},
				{
					key: 'status',
					label: this.FormMSG(43, 'Status'),
					sortable: true
				},
				{
					key: 'date',
					label: this.FormMSG(41, 'Date'),
					formatter: (value) => {
						return new moment(value).format('DD/MM/YYYY');
					},
					sortable: true
				},
				{
					key: 'crew_member',
					label: this.FormMSG(42, 'Crew member'),
					sortable: true
				},
				{
					key: 'encoder',
					label: this.FormMSG(92, 'Encoded By'),
					sortable: false
				},
				{
					key: 'tsDay.strTime',
					label: this.FormMSG(26, 'Start'),
					formatter: (value) => {
						return moment(value).format('HH:mm');
					},
					sortable: true
				},
				{
					key: 'tsDay.endTime',
					label: this.FormMSG(27, 'End'),
					formatter: (value) => {
						return moment(value).format('HH:mm');
					},
					sortable: false
				},
				{
					key: 'worked',
					label: this.FormMSG(44, 'Worked'),
					sortable: true
				},
				{
					key: 'dayType',
					label: this.FormMSG(45, 'Type'),
					sortable: true
				},
				{
					key: 'ovt',
					label: this.FormMSG(46, 'Ovt'),
					sortable: true
				},
				this.transport,
				this.nigth,
				this.anticipated,
				this.preCall,
				{
					key: 'lunch',
					label: this.FormMSG(51, 'Lunch'),
					sortable: true
				},
				this.totPerDiem,
				{
					key: 'allowances',
					label: this.FormMSG(53, 'Allowances'),
					sortable: true
				},
				{
					key: 'dayRate',
					label: this.FormMSG(54, 'Rate'),
					sortable: true
				},
				{
					key: 'co2',
					label: this.FormMSG(55, 'CO2'),
					sortable: true
				}
			];
			if (this.canSeeSalary) {
				fields.push({
					key: 'salary',
					label: this.FormMSG(56, 'Salary'),
					sortable: true
				});
			}
			fields.push({
				key: 'remove',
				label: this.FormMSG(57, 'Remove'),
				sortable: false
			});
			return fields;
		},
		fieldsTimeCardsPlanning() {
			return this.headerTabPlanning;
		},
		fieldsTimesheets() {
			let fields = [
				{
					key: 'select',
					label: this.FormMSG(58, 'Select')
				},
				{
					key: 'status',
					label: this.FormMSG(60, 'Status'),
					sortable: true
				},
				{
					key: 'startDate',
					label: this.FormMSG(26, 'Start'),
					formatter: (value) => {
						return new moment(value).format('DD/MM/YYYY');
					},
					sortable: true
				},
				{
					key: 'endDate',
					label: this.FormMSG(27, 'End'),
					formatter: (value) => {
						return new moment(value).format('DD/MM/YYYY');
					},
					sortable: false
				},
				{
					key: 'crew_member',
					label: this.FormMSG(59, 'Crew member'),
					sortable: true
				},
				{
					key: 'encoder',
					label: this.FormMSG(92, 'Encoded By'),
					sortable: false
				},
				{
					key: 'worked',
					label: this.FormMSG(61, 'Worked'),
					sortable: true
				},
				this.weeklyOverTime,
				this.dailyOvertime,
				this.transport,
				this.nigth,
				this.anticipated,
				this.preCall,
				this.perDiem,
				{
					key: 'allowances',
					label: this.FormMSG(69, 'Allowances'),
					sortable: true
				},
				{
					key: 'co2',
					label: this.FormMSG(70, 'CO2'),
					sortable: true
				}
			];
			if (this.canSeeSalary) {
				fields.push({
					key: 'salary',
					label: this.FormMSG(71, 'Salary'),
					sortable: true
				});
			}
			/**
			 * No need to remove Timesheets, there maybe item already validate/submit inside.
			 */
			// fields.push({
			// 	key: 'remove',
			// 	label: this.FormMSG(72, 'Remove'),
			// 	sortable: false
			// });
			return fields;
		},
		currentExpenseTab: {
			get() {
				if (this.$route.query.activeSecondTab) {
					return 1;
				}
				return this.timesheetActiveTab;
			},
			set(tab) {
				this.handleTabChanged(tab);
			}
		},
		totPerDiem() {
			if (this.showLunchPerDiem || this.showHotelPerDiem || this.showDinnerPerDiem || this.showAbroadPerDiem) {
				return {
					key: 'totPerDiem',
					label: this.FormMSG(52, 'Per Diem'),
					sortable: true
				};
			}
			return null;
		},
		transport() {
			if (this.showTransport) {
				return {
					key: 'transport',
					label: this.FormMSG(47, 'Transport'),
					sortable: true
				};
			}
			return null;
		},
		weeklyOverTime() {
			if (this.showWeeklyOvt || this.showWeeklyOvt1 || this.showWeeklyOvt2) {
				return {
					key: 'weeklyOvt',
					label: this.FormMSG(62, 'Weekly ovt'),
					sortable: true
				};
			}
			return null;
		},
		dailyOvertime() {
			if (this.showOvt || this.showOvt1 || this.showOvt2) {
				return {
					key: 'dailyOvt',
					label: this.FormMSG(63, 'Daily Ovt'),
					sortable: true
				};
			}
			return null;
		},
		anticipated() {
			if (this.showTooEarlyHours) {
				return {
					key: 'anticipated',
					label: this.FormMSG(49, 'Anticipated'),
					sortable: true
				};
			}
			return null;
		},
		nigth() {
			if (this.showNightHours) {
				return {
					key: 'night',
					label: this.FormMSG(48, 'Night'),
					sortable: true
				};
			}
			return null;
		},
		perDiem() {
			if (this.showLunchPerDiem || this.showHotelPerDiem || this.showDinnerPerDiem || this.showAbroadPerDiem) {
				return {
					key: 'perDiem',
					label: this.FormMSG(68, 'Per Diem'),
					sortable: true
				};
			}
			return null;
		},
		preCall() {
			if (this.showPreCall) {
				return {
					key: 'precall',
					label: this.FormMSG(50, 'Precall'),
					sortable: true
				};
			}
			return null;
		},
		showOvt() {
			return store.getCurrentProjectConfig().useOvertime;
		},
		showOvt1() {
			return store.getCurrentProjectConfig().useOvt1;
		},
		showOvt2() {
			return store.getCurrentProjectConfig().useOvt2;
		},
		showWeeklyOvt() {
			return store.getCurrentProjectConfig().useWeeklyOvt;
		},
		showWeeklyOvt1() {
			return store.getCurrentProjectConfig().useWeeklyOvt1;
		},
		showWeeklyOvt2() {
			return store.getCurrentProjectConfig().useWeeklyOvt2;
		},
		showTransport() {
			return store.getCurrentProjectConfig().useHomeToWorkTime;
		},
		showLunchPerDiem() {
			return store.getCurrentProjectConfig().useLunchPerDiem;
		},
		showHotelPerDiem() {
			return store.getCurrentProjectConfig().useHotelPerDiem;
		},
		showDinnerPerDiem() {
			return store.getCurrentProjectConfig().useDinnerPerDiem;
		},
		showAbroadPerDiem() {
			return store.getCurrentProjectConfig().useAbroadPerDiem;
		},
		showTooEarlyHours() {
			return store.getCurrentProjectConfig().useTooEarlyHours;
		},
		showNightHours() {
			return store.getCurrentProjectConfig().useNightHours;
		},
		showPreCall() {
			return store.getCurrentProjectConfig().useBeforeCallTime;
		},
		rendConfirmModalTxt() {
			const _t = this.FormMSG;
			return {
				title: _t(235, 'Please Confirm'),
				okTitle: _t(236, 'YES'),
				cancelTitle: _t(237, 'NO')
			};
		}
	},
	watch: {
		'$screen.width': {
			handler(val) {
				if (val <= 567) {
					this.showGridDetails = true;
				}
			},
			immediate: true
		},
		currentExpenseTab: {
			async handler(newVal) {
				if (newVal === 1) {
					if (this.$route.query.activeFilter == this.groupByDate || !this.$route.query.activeFilter) {
						this.miniSpinnerLoadingTimeSheet = true;
						this.groupActionCellTimesheets = this.groupByDate;
						this.groupActionCellTimesheets = this.groupByDate;
						this.groupByActionValue = true;
						this.TabAction = this.timesheets_Two;
						let resultTimesheets = await this.getProjectUserSalariesDataInitial();
						this.Timesheets = resultTimesheets;
						this.allDataTimesheets = resultTimesheets;
						this.formChanged(this.DateDefaultSelect, this.timesheets_Two);
						this.miniSpinnerLoadingTimeSheet = false;
						this.currentExpenseTab = 1;
					} else {
						setTimeout(async () => {
							this.miniSpinnerLoadingTimeSheet = true;
							await this.setFilter(this.$route.query.activeFilter);
							this.miniSpinnerLoadingTimeSheet = false;
						}, 250);
					}
				} else {
					this.currentExpenseTab = 0;
				}
			},
			deep: true,
			immediate: true
		},
		TimeCards: {
			handler(val) {
				return val;
			},
			immediate: true,
			deep: true
		},
		departmentPersist: {
			handler(newVal) {
				return newVal;
			},
			immediate: true,
			deep: true
		}
	},
	async created() {
		if (this.$route.query.activeSecondTab) {
			this.setTabAction(this.timesheets_Two);
		} else {
			this.fromMount = false;
			this.reloadData();
		}
	},
	methods: {
		initRefreshSelectedPlanning() {
			const planning = this.$refs['planning-view-table'];
			if (planning) {
				planning.initActionsInPlanning();
			}
		},
		handleRefreshReject() {
			this.handleRefreshData();
		},
		async handleRefreshData() {
			if (this.groupActionCellTimeCards !== this.planningView) {
				try {
					this.$nextTick(() => {
						this.miniSpinnerLoadingTimeCards = true;
						if (this.TabAction === this.timecards_One) {
							this.setFilter(this.groupActionCellTimeCards);
						}
						if (this.TabAction === this.timesheets_Two) {
							this.setFilter(this.groupActionCellTimesheets);
						}
						this.miniSpinnerLoadingTimeCards = false;
						this.hideModal();
					});
				} catch (error) {
					console.error(error);
				}
			} else {
				let arrays = [];
				for (let i = 0; i <= this.recordOffSet; i++) {
					let Filter = {
						...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
						recordLimit: this.recordLimit,
						recordOffSet: i,
						department: this.departmentPersist.value,
						keyWord: this.valueToSearch
					};
					delete Filter.activateCrewAccessRestriction;
					let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
					arrays.push(result);
				}
				this.getTotalsTsDaysPlanning();
				let data = arrays.flat(Infinity);
				this.TimeCards = data;
				this.hideModal();
				this.initRefreshSelectedPlanning();
			}
		},
		async handleSelectedDay(data) {
			let result = [];
			if (data == -1) {
				result = [
					...(await getProjectOnlyUserTsDay({
						startDate: moment(this.DateDefaultSelect.value, 'MM/YYYY').startOf('month').format('YYYY-MM-DD') + 'T00:00:00Z',
						endDate: moment(this.DateDefaultSelect.value, 'MM/YYYY').endOf('month').format('YYYY-MM-DD') + 'T00:00:00Z'
					}))
				].map((item) => ({
					...item,
					crew_member: item.fullName,
					validatedText: this.GetTextFromMenuNumberAndMenuValue(1008, item.status),
					data: [{ ...item, crew_member: item.fullName }]
				}));
				this.TimeCards = result;
			} else {
				result = [
					...(await getProjectOnlyUserTsDay({
						startDate: moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD') + 'T00:00:00Z',
						endDate: moment(data, 'DD/MM/YYYY').format('YYYY-MM-DD') + 'T00:00:00Z'
					}))
				].map((item) => ({
					...item,
					crew_member: item.fullName,
					validatedText: this.GetTextFromMenuNumberAndMenuValue(1008, item.status),
					data: [{ ...item, crew_member: item.fullName }]
				}));
				this.TimeCards = result;
			}
		},
		handleSelectedFormFilter(data) {
			this.recordLimitPerDate = 10;
			this.recordOffSetPerDate = 0;
			this.DateDefaultSelect = data.e;
			this.formChanged(data.e, data.id);
		},
		...mapActions({
			handleTabChanged: 'expenses/setActiveTab'
		}),
		async setFilter(item) {
			this.filter = '';
			this.groupActionCellTimeCards = item;
			this.groupActionCellTimesheets = item;
			this.TimeCards = [];
			this.Timesheets = [];
			this.allDataTimeCards = [];
			this.allDataTimesheets = [];
			this.planningToSend = [];
			this.dataPlanningSelect = [];
			this.isLoading = this.miniSpinnerLoadingTimeCards || this.miniSpinnerLoadingTimeSheet ? false : true;
			if (this.TabAction === this.timecards_One && this.groupActionCellTimeCards === this.planningView) {
				this.isLoading = true;
				let arrays = [];
				for (let i = 0; i <= this.recordOffSet; i++) {
					let Filter = {
						...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
						recordLimit: this.recordLimit,
						recordOffSet: i,
						department: this.departmentPersist.value,
						keyWord: this.valueToSearch
					};
					delete Filter.activateCrewAccessRestriction;
					let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
					arrays.push(result);
				}
				let data = arrays.flat(Infinity);
				let _dateSplit = this.DateDefaultSelect.value.split`/`;
				let month = +_dateSplit[0];
				let year = +_dateSplit[1];
				const nbDay = new Date(year, month, 0).getDate();
				let dateHeader = [];
				const langCurrent = this.currentLang;
				for (let n = 1; n <= nbDay; n++) {
					let formattedDate = moment(n.toString().padStart('2', '0') + '/' + this.DateDefaultSelect.value, 'DD/MM/YYYY')
						.locale(`${langCurrent}`)
						.format('DD ddd');
					dateHeader.push({
						key: `${n.toString().padStart('2', '0') + '/' + this.DateDefaultSelect.value}`,
						label: formattedDate,
						sortable: true
					});
				}
				this.headerTabPlanning = [
					{
						key: 'crew_member',
						label: this.FormMSG(42, 'Crew member'),
						sortable: true
					},
					...dateHeader
				];
				this.TimeCards = data;
				this.allDataTimeCards = data;
				this.isLoading = false;
				return;
			}
			if (this.TabAction === this.timecards_One && this.groupActionCellTimeCards === this.groupByDate) {
				this.TimeCards = await this.getProjectUserTsDaysDataInitial();
				this.allDataTimeCards = this.TimeCards;
				this.formChanged(this.DateDefaultSelect, this.timecards_One);
				this.isLoading = false;
				return;
			}
			if (
				this.TabAction === this.timecards_One &&
				(this.groupActionCellTimeCards === this.groupByPerson || this.groupActionCellTimeCards === this.groupByStatus)
			) {
				this.TimeCards = await this.getProjectUserTsDaysDataInitial();
				this.allDataTimeCards = this.TimeCards;
				this.isLoading = false;
				return;
			}
			if (this.TabAction === this.timesheets_Two && this.groupActionCellTimesheets === this.groupByDate) {
				this.Timesheets = await this.getProjectUserSalariesDataInitial();
				this.allDataTimesheets = this.Timesheets;
				this.formChanged(this.DateDefaultSelect, this.timesheets_Two);
				this.isLoading = false;
				return;
			}
			if (this.TabAction === this.timesheets_Two && this.groupActionCellTimesheets === this.groupByPerson) {
				this.Timesheets = await this.getProjectUserSalariesDataInitial();
				this.allDataTimesheets = this.Timesheets;
				this.isLoading = false;
				return;
			}
			if (this.TabAction === this.timesheets_Two && this.groupActionCellTimesheets === this.groupByStatus) {
				this.Timesheets = [...new Set([...(await this.getProjectUserSalariesDataInitial())].map((item) => item.status))].map((_status) => {
					return {
						id: _status,
						date: 'date-01-04-' + Math.floor(Math.random() * 1000000),
						status: _status,
						data: [
							{
								id: _status,
								date: 'date-01-04-' + Math.floor(Math.random() * 1000000),
								status: _status,
								timesheet: {
									id: _status
								}
							}
						]
					};
				});
				this.allDataTimesheets = this.Timesheets;
				this.isLoading = false;
				return;
			}
		},
		showModal() {
			this.isActionCrud = this.addData;
			this.Open = true;
		},
		hideModal() {
			this.Open = false;
			this.dataPlanningSelect = [];
			this.planningToSend = [];
			this.editData = {};
			this.isActionCrud = '';
			this.isPersistDataPlanning = false;
		},
		closeModal() {
			this.Open = false;
			this.isPersistDataPlanning = true;
			this.editData = {};
		},
		async reloadData() {
			this.departmentAutorization = (await GetEncodingValidation(store.getCurrentProjectConfig().id, store.userID())).department;
			this.allDepartment = await getDepartments(false, false);
			await this.getDataInit();
		},
		setFilterName(name, value) {
			let obj = {};
			obj[name] = value;
			return { ...obj, projectId: +store.projectID(), activateCrewAccessRestriction: true };
		},
		async getDataInit() {
			this.groupActionCellTimeCards = this.planningView;
			this.groupActionCellTimesheets = this.planningView;
			this.groupByActionValue = this.filterPlanning;
			this.isLoading = this.miniSpinnerLoadingTimeCards || this.miniSpinnerLoadingTimeSheet ? false : true;
			let data = [...(await this.getProjectUsersTsDaysPlanningDataInitial())];
			let _dateSplit = this.DateDefaultSelect.value.split`/`;
			let month = +_dateSplit[0];
			let year = +_dateSplit[1];
			const nbDay = new Date(year, month, 0).getDate();
			let dateHeader = [];
			const langCurrent = this.currentLang;
			for (let n = 1; n <= nbDay; n++) {
				let formattedDate = moment(n.toString().padStart('2', '0') + '/' + this.DateDefaultSelect.value, 'DD/MM/YYYY')
					.locale(`${langCurrent}`)
					.format('DD ddd');
				dateHeader.push({
					key: `${n.toString().padStart('2', '0') + '/' + this.DateDefaultSelect.value}`,
					label: formattedDate,
					sortable: true
				});
			}
			this.headerTabPlanning = [
				{
					key: 'crew_member',
					label: this.FormMSG(42, 'Crew member'),
					sortable: true
				},
				...dateHeader
			];
			this.TimeCards = data;
			this.allDataTimeCards = data;
			this.isLoading = false;
		},
		async getProjectUsersTsDaysPlanningDate() {
			let result = [...(await getProjectUsersTsDaysPlanning())];
			return result;
		},
		async getProjectUsersTsDaysPlanningDataInitial() {
			let Filter = {
				...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
				recordLimit: this.recordLimit,
				recordOffSet: this.recordOffSet,
				department: this.departmentPersist.value,
				keyWord: this.valueToSearch
			};
			const globalFilter = {
				...Filter,
				recordLimit: null,
				recordOffSet: null,
				department: this.departmentPersist.value,
				keyWord: this.valueToSearch
			};
			delete Filter.activateCrewAccessRestriction;
			let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
			this.getTotalsTsDaysPlanning();
			return result;
		},
		async getTotalsTsDaysPlanning() {
			let Filter = {
				...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
				recordLimit: null,
				recordOffSet: null,
				department: null,
				keyWord: null
			};
			const totals = [...(await getProjectUsersTsDaysPlanning(Filter))].length;
			this.totalsPlanningTsDays = totals;
			return this.totalsPlanningTsDays;
		},
		async getProjectUserTsDaysDataInitial() {
			let result = [];
			let filter = {};
			if (this.TabAction === this.timecards_One && this.groupActionCellTimeCards === this.groupByPerson) {
				filter = {
					...this.setFilterName(this.groupByPerson, this.groupByActionValue),
					activateCrewAccessRestriction: true
				};
			}
			if (this.TabAction === this.timecards_One && this.groupActionCellTimeCards === this.groupByStatus) {
				filter = {
					...this.setFilterName(this.groupByStatus, this.groupByActionValue),
					activateCrewAccessRestriction: true
				};
			}
			if (this.TabAction === this.timecards_One && this.groupActionCellTimeCards === this.groupByDate) {
				filter = {
					startDate: moment(this.DateDefaultSelect.value, 'MM/YYYY').startOf('month').format('YYYY-MM-DD') + 'T00:00:00Z',
					endDate: moment(this.DateDefaultSelect.value, 'MM/YYYY').endOf('month').format('YYYY-MM-DD') + 'T00:00:00Z',
					recordLimit: this.recordLimitPerDate,
					recordOffSet: this.recordOffSetPerDate,
					activateCrewAccessRestriction: true
				};
			}
			result = [...(await getProjectOnlyUserTsDay(filter))].map((item) => ({
				...item,
				crew_member: item.fullName,
				validatedText: this.GetTextFromMenuNumberAndMenuValue(1008, item.status),
				data: [{ ...item, crew_member: item.fullName }]
			}));
			delete filter.recordLimit;
			delete filter.recordOffSet;
			let setDataFilterAllRecords = {
				...filter
			};
			this.totalAllPageRecords = [...(await getProjectOnlyUserTsDay(setDataFilterAllRecords))].length;
			return result;
		},
		async getProjectUserSalariesDataInitial() {
			let Filter = {};
			if (this.TabAction === this.timesheets_Two && this.groupActionCellTimesheets === this.groupByDate) {
				Filter = {
					...this.setFilterName(this.groupByDateOnly, this.groupByActionValue),
					activateCrewAccessRestriction: true
				};
			} else {
				Filter = {
					...this.setFilterName(this.groupActionCellTimesheets, this.groupByActionValue),
					activateCrewAccessRestriction: true
				};
			}
			let result = [...(await getProjectOnlyUserTimesheets(Filter))].map((item) => ({
				...item,
				isSelected: false,
				crew_member: item.fullName,
				data: [{ ...item, crew_member: item.fullName }]
			}));
			return result;
		},
		async initDataPlanningView() {
			let arrays = [];
			for (let i = 0; i <= this.recordOffSet; i++) {
				let Filter = {
					...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
					recordLimit: this.recordLimit,
					recordOffSet: i,
					department: this.departmentPersist.value,
					keyWord: this.valueToSearch
				};
				let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
				arrays.push(result);
			}
			let data = arrays.flat(Infinity);
			this.TimeCards = data;
			this.allDataTimeCards = data;
		},
		async onSearch(searchValue, action, idTable) {
			this.filter = searchValue;
			this.valueToSearch = searchValue.replace(/[\s]+/gi, '%');
			if (idTable === this.timecards_One) {
				let DATA = this.allDataTimeCards;
				if (this.filterPlanning === true && this.groupActionCellTimeCards === this.planningView) {
					if (searchValue.length === 0) {
						this.TimeCards = DATA;
					} else {
						if (action) {
							this.TimeCards = DATA;
						} else {
							let arrays = [];
							for (let i = 0; i <= this.recordOffSet; i++) {
								let Filter = {
									...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
									recordLimit: this.recordLimit,
									recordOffSet: i,
									department: this.departmentPersist.value,
									keyWord: this.valueToSearch
								};
								let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
								arrays.push(result);
							}
							let data = arrays.flat(Infinity);
							this.TimeCards = data;
						}
					}
				} else {
					if (searchValue.length === 0) {
						this.TimeCards = DATA;
					} else {
						if (action) {
							this.TimeCards = DATA;
						} else {
							this.TimeCards = DATA.filter((item) => {
								if (
									item.fullName.toUpperCase().includes(searchValue.toUpperCase()) ||
									item.functionName.toUpperCase().includes(searchValue.toUpperCase())
								) {
									return true;
								}
								return false;
							});
						}
					}
				}
			}
			if (idTable === this.timesheets_Two) {
				let DATA = this.allDataTimesheets;
				if (searchValue.length === 0) {
					this.Timesheets = DATA;
				} else {
					if (action) {
						this.Timesheets = DATA;
					} else {
						if (searchValue.length <= 1) {
							this.Timesheets = DATA;
						} else {
							this.Timesheets = DATA.filter((item) => {
								if (
									item.fullName.toUpperCase().includes(searchValue.toUpperCase()) ||
									item.functionName.toUpperCase().includes(searchValue.toUpperCase())
								) {
									return true;
								}
								return false;
							});
						}
					}
				}
			}
		},
		async formChanged(_date, idTable) {
			// on change date to filter by date
			if (this.isRefresh === false) {
				if (idTable === this.timecards_One) {
					let DATA = this.allDataTimeCards;
					if (_date.value !== 0) {
						this.miniSpinnerLoadingTimeCards = true;
						this.TimeCards = await this.getProjectUserTsDaysDataInitial();
						this.miniSpinnerLoadingTimeCards = false;
					}
				}
				if (idTable === this.timesheets_Two) {
					let DATA = this.allDataTimesheets;
					if (_date.value !== 0) {
						this.isLoading = true;
						this.Timesheets = DATA.filter((item) => {
							if (moment(item.startDate).format('MM/YYYY').includes(_date.value)) {
								return true;
							}
							return false;
						});
						this.isLoading = false;
					}
				}
			} else {
				let resultTimeCardsDATA = await this.getProjectUserTsDaysDataInitial();
				this.allDataTimeCards = resultTimeCardsDATA;
				let DATA = this.allDataTimeCards;
				this.TimeCards = DATA.filter((item) => {
					if (moment(item.date).format('MM/YYYY').includes(_date.value)) {
						return true;
					}
					return false;
				});
				this.isRefresh = false;
			}
		},
		async formChangedPlanningView(_date, idTable) {
			this.isLoading = true;
			let _dateSplit = _date.value.split`/`;
			let month = +_dateSplit[0];
			let year = +_dateSplit[1];
			const nbDay = new Date(year, month, 0).getDate();
			let dateHeader = [];
			const langCurrent = this.currentLang;

			for (let n = 1; n <= nbDay; n++) {
				let formattedDate = moment(n.toString().padStart('2', '0') + '/' + _date.value, 'DD/MM/YYYY')
					.locale(`${langCurrent}`)
					.format('DD ddd');
				dateHeader.push({
					key: `${n.toString().padStart('2', '0') + '/' + _date.value}`,
					label: formattedDate,
					sortable: true
				});
			}

			this.headerTabPlanning = [
				{
					key: 'crew_member',
					label: this.FormMSG(42, 'Crew member'),
					sortable: true
				},
				...dateHeader
			];

			this.DateDefaultSelect = _date;

			let arrays = [];
			for (let i = 0; i <= this.recordOffSet; i++) {
				let Filter = {
					...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
					recordLimit: this.recordLimit,
					recordOffSet: i,
					department: this.departmentPersist.value,
					keyWord: this.valueToSearch
				};
				let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
				arrays.push(result);
			}
			let data = arrays.flat(Infinity);
			this.allDataTimeCards = data;
			this.TimeCards = data;
			this.isLoading = false;
		},
		async deleteAction(item, idTable) {
			if (idTable === this.timecards_One) {
				let txt = this.FormMSG(74, 'Please confirm that you want delete this timesheet');

				let result = this.$bvModal
					.msgBoxConfirm(txt, {
						title: txt,
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'danger',
						okTitle: 'ok',
						cancelTitle: 'Cancel',
						footerClass: 'p-2',
						hideHeaderClose: false,
						centered: false
					})
					.then(async (v) => {
						if (!v) return;
						else {
							let result = await deleteTimeCardsTsDay(item.tsDay.id);
							result &&
								this.createToastForMobile(
									this.FormMSG(9, 'Success'),
									this.FormMSG(75, 'Timesheets item delete successfully'),
									'',
									'success',
									true
								);
							return result && true;
						}
					})
					.catch(() => {
						return false;
					});
				return result;
			}
			if (idTable === this.timesheets_Two) {
				let txt = this.FormMSG(74, 'Please confirm that you want delete this timesheet');

				let result = this.$bvModal
					.msgBoxConfirm(txt, {
						title: txt,
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'danger',
						okTitle: 'ok',
						cancelTitle: 'Cancel',
						footerClass: 'p-2',
						hideHeaderClose: false,
						centered: false
					})
					.then(async (v) => {
						if (!v) return;
						else {
							let result = await deleteTimeCardsTsDay(item.timesheet.id);
							result &&
								this.createToastForMobile(
									this.FormMSG(9, 'Success'),
									this.FormMSG(75, 'Timesheets item delete successfully'),
									'',
									'success',
									true
								);
							return result && true;
						}
					})
					.catch(() => {
						return false;
					});
				return result;
			}
		},
		async setTabAction(name) {
			const query = {
				tab: undefined,
				activeFilter: undefined
			};
			this.DateDefaultSelect = {
				value: moment(Date.now()).format('MM/YYYY'),
				text: moment(Date.now()).format('MMMM YYYY')
			};
			this.TabAction = name;
			this.groupByFilter = this.planningView;
			if (this.TabAction === this.timecards_One) {
				this.miniSpinnerLoadingTimeCards = true;
				this.groupActionCellTimeCards = this.planningView;
				this.groupActionCellTimesheets = '';
				this.groupByActionValue = this.filterPlanning;
				this.TimeCards = [];
				this.allDataTimeCards = [];
				let arrays = [];
				for (let i = 0; i <= this.recordOffSet; i++) {
					let Filter = {
						...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
						recordLimit: this.recordLimit,
						recordOffSet: i,
						department: this.departmentPersist.value,
						keyWord: this.valueToSearch
					};
					let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
					arrays.push(result);
				}
				let data = arrays.flat(Infinity);
				this.allDataTimeCards = data;
				let _dateSplit = this.DateDefaultSelect.value.split`/`;
				let month = +_dateSplit[0];
				let year = +_dateSplit[1];
				const nbDay = new Date(year, month, 0).getDate();
				let dateHeader = [];
				const langCurrent = this.currentLang;
				for (let n = 1; n <= nbDay; n++) {
					let formattedDate = moment(n.toString().padStart('2', '0') + '/' + this.DateDefaultSelect.value, 'DD/MM/YYYY')
						.locale(`${langCurrent}`)
						.format('DD ddd');
					dateHeader.push({
						key: `${n.toString().padStart('2', '0') + '/' + this.DateDefaultSelect.value}`,
						label: formattedDate,
						sortable: true
					});
				}
				this.headerTabPlanning = [
					{
						key: 'crew_member',
						label: this.FormMSG(42, 'Crew member'),
						sortable: true
					},
					...dateHeader
				];
				this.TimeCards = data;
				this.miniSpinnerLoadingTimeCards = false;
			}
			if (this.TabAction === this.timesheets_Two) {
				this.allDataTimesheets = [];
				this.Timesheets = [];
				this.miniSpinnerLoadingTimeSheet = true;
				this.groupActionCellTimeCards = '';
				this.groupActionCellTimesheets = this.groupByDate;
				this.groupByActionValue = true;
				let resultTimesheets = await this.getProjectUserSalariesDataInitial();
				this.Timesheets = resultTimesheets;
				this.allDataTimesheets = resultTimesheets;
				this.formChanged(this.DateDefaultSelect, this.timesheets_Two);
				this.miniSpinnerLoadingTimeSheet = false;
				query.tab = this.timesheets_Two;
				if (this.$route.query.activeFilter) query.activeFilter = this.$route.query.activeFilter;
			}

			this.goTo(query.tab, query.activeFilter);
		},
		setStatusExpenseDefault(value) {
			this.expenseStatusDefault = value;
		},
		dateToLiteral(timesheetDate) {
			const langCurrent = this.currentLang;
			const fullLiteralDate = moment(timesheetDate).locale(`${langCurrent}`).format('DD MMMM YYYY');

			return fullLiteralDate;
		},
		async handleSelectDepartementChange(department) {
			this.departmentPersist = department;
			if (this.departmentPersist.value !== null) {
				let arrays = [];
				for (let i = 0; i <= this.recordOffSet; i++) {
					let Filter = {
						...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
						recordLimit: this.recordLimit,
						recordOffSet: i,
						department: this.departmentPersist.value,
						keyWord: this.valueToSearch
					};
					let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
					arrays.push(result);
				}
				let data = arrays.flat(Infinity);
				this.allDataTimeCards = data;
				this.TimeCards = data;
			} else {
				this.isLoading = true;
				let arrays = [];
				for (let i = 0; i <= this.recordOffSet; i++) {
					let Filter = {
						...this.setFilterName('startDate', moment(`01/${this.DateDefaultSelect.value}`, 'DD/MM/YYYY', true).format()),
						recordLimit: this.recordLimit,
						recordOffSet: i,
						department: this.departmentPersist.value,
						keyWord: this.valueToSearch
					};
					let result = [...(await getProjectUsersTsDaysPlanning(Filter))].map((item) => ({ ...item, isSelected: false }));
					arrays.push(result);
				}
				let data = arrays.flat(Infinity);
				this.allDataTimeCards = data;
				this.TimeCards = data;
				this.isLoading = false;
			}
		},
		setDataSizeModalPlanning(dataPlanning) {
			this.dataPlanningSelect = dataPlanning;
			this.planningToSend = dataPlanning;
			if (this.editData !== null) {
				this.isActionCrud = this.updateData;
			} else {
				this.isActionCrud = this.addData;
			}
		},
		sendDataModalPlanning(dataPlanning) {
			this.dataPlanningSelect = dataPlanning;
			this.planningToSend = dataPlanning;
			if (this.editData !== null) {
				this.isActionCrud = this.updateData;
			} else {
				this.isActionCrud = this.addData;
			}
		},
		showModalPlanningContextUpdate(dataPlanning) {
			if (dataPlanning.length !== 0) {
				this.isActionCrud = this.updateData;
				this.dataPlanningSelect = dataPlanning;
				this.planningToSend = dataPlanning;
				const item = dataPlanning[0];
				this.editData = item;
				this.Open = true;
			} else {
				this.dataPlanningSelect = dataPlanning;
				this.planningToSend = dataPlanning;
				this.editData = {};
				this.Open = false;
			}
		},
		async sendForValidationPlanning(item) {
			const confirmationMessage =
				item.length === 1
					? this.FormMSG(239, `Please confirm that you want to send the timesheet for validation`)
					: this.FormMSG(238, `Please confirm that you want to send all unsent timesheets to validation`);

			this.$bvModal
				.msgBoxConfirm(confirmationMessage, {
					title: this.rendConfirmModalTxt.title,
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'primary',
					okTitle: this.rendConfirmModalTxt.okTitle,
					cancelTitle: this.rendConfirmModalTxt.cancelTitle,
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: false
				})
				.then(async (value) => {
					if (value) {
						let arrays = [];
						this.isLoading = true;
						for (let i = 0; i < item.length; i++) {
							let id = +item[i].id;
							let result = await submitSelectedTimesheet(id);
							arrays.push(result);
						}
						if (arrays.every((item) => item === true)) {
							let successMessage =
								item.length === 1
									? this.FormMSG(13, 'The timesheet has been submitted for validation')
									: this.FormMSG(12, 'All timesheets have been submitted for validation');
							let strTitle = this.FormMSG(9, 'Success');
							this.createToastForMobile(strTitle, successMessage, '', 'success', true);
							this.handleRefreshData();
						} else {
							let strTitle = this.FormMSG(81, 'Warning');
							let warningMessage =
								item.length === 1
									? this.FormMSG(83, 'Check the timesheet because it has not been sent for validation')
									: this.FormMSG(82, 'Check the timesheet(s) because there is a timesheet that has not been sent for validation');

							this.createToastForMobile(strTitle, warningMessage, '', 'warning', true);
							this.handleRefreshData();
						}
						this.isLoading = false;
					}
				})
				.catch((err) => console.log(err));
		},
		async validateTsDays(item) {
			try {
				if (item && item.length !== 0) {
					const result = item.map(async ({ id }) => {
						const newID = +id;
						const exc = await validateTsDays(newID);
						return exc;
					});
					if (result !== null) {
						this.successModal = true;
					}
				}
			} finally {
				this.handleRefreshData();
			}
		},
		changeDateDefaultSelect(item) {
			if (this.departmentPersist.value === null) {
				this.DateDefaultSelect = item;
				this.formChangedPlanningView(this.DateDefaultSelect, this.timecards_One);
			} else {
				this.DateDefaultSelect = item;
				this.formChangedPlanningView(this.DateDefaultSelect, this.timecards_One);
				setTimeout(() => {
					this.handleSelectDepartementChange(this.departmentPersist);
				}, 1000);
			}
		},
		setIsNavigateInitDate(boolean) {
			this.isNavigateInitDate = boolean;
		},
		async getDataFromPagePlanning(recordOffSet) {
			const onLoading = async () => {
				this.isActiveBusy = true;
				this.recordOffSet += recordOffSet;
				let data = [...(await this.getProjectUsersTsDaysPlanningDataInitial())];
				let nextDataTimeCards = [...this.TimeCards, ...data];
				let nextDataAllTimeCards = [...this.allDataTimeCards, ...data];
				this.TimeCards = nextDataTimeCards;
				this.allDataTimeCards = nextDataAllTimeCards;
				this.isActiveBusy = false;
			};
			await this.showLoader(onLoading, 'green-planning-item');
		},
		resetDataAfterAddUpdate() {
			this.dataPlanningSelect = [];
			this.planningToSend = [];
		},
		deleteItemPlanning(item) {
			// let _id = +item[0].tsDays[0].id;
			let txt = this.FormMSG(74, 'Please confirm that you want delete this timesheet');
			let result = this.$bvModal
				.msgBoxConfirm(txt, {
					title: txt,
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'ok',
					cancelTitle: 'Cancel',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: false
				})
				.then(async (v) => {
					if (!v) return;
					else {
						this.isLoading = true;
						const response = await Promise.all(
							item.map(async ({ id }) => {
								const newID = +id;
								const exc = await deleteTimeCardsTsDay(newID);
								if (exc) {
									return newID;
								}
								return null;
							})
						);
						const newResult = await new Promise((resolve, _) => resolve(response)).then((newResponse) => {
							if (newResponse.length !== 0) {
								const arraysId = newResponse.filter((id) => id !== null);
								const newTimeCards = this.TimeCards.map((item) => {
									const { tsDays } = item;
									let res = {
										...item,
										tsDays: tsDays.filter(({ id }) => {
											const newID = +id;
											if ([...arraysId].includes(newID)) {
												return false;
											}
											return true;
										})
									};
									return res;
								});
								this.TimeCards = newTimeCards;
								this.createToastForMobile(
									this.FormMSG(9, 'Success'),
									this.FormMSG(75, 'Timesheets item delete successfully'),
									'',
									'success',
									true
								);
								this.initRefreshSelectedPlanning();
								this.isLoading = false;
							} else {
								this.isLoading = false;
							}
						});
						return newResult;
					}
				})
				.catch(() => {
					return false;
				});
			return result;
		},
		async refreshDataItemPerDate() {
			this.recordLimitPerDate = this.recordLimitPerDate;
			this.recordOffSetPerDate = this.recordOffSetPerDate;
			let result = await this.getProjectUserTsDaysDataInitial();
			this.TimeCards = result;
		},
		async changePageSelectLimit(page) {
			this.recordLimitPerDate = page;
			this.recordOffSetPerDate = 0;
			let result = await this.getProjectUserTsDaysDataInitial();
			this.TimeCards = result;
		},
		async handleNextPerDate(recordOffSetPerDate) {
			this.recordOffSetPerDate = recordOffSetPerDate;
			let result = await this.getProjectUserTsDaysDataInitial();
			this.TimeCards = result;
		},
		async handlePreviousPerDate(recordOffSetPerDate) {
			this.recordOffSetPerDate = recordOffSetPerDate;
			let result = await this.getProjectUserTsDaysDataInitial();
			this.TimeCards = result;
		},
		goTo(tab, filter) {
			if (!this.fromMount) {
				const query = {};
				if (tab == this.timesheets_Two) query['activeSecondTab'] = 1;
				if (filter) query['activeFilter'] = filter;
				this.$router.push({ query });
			} else this.fromMount = false;
		}
	}
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
	cursor: pointer;
}
</style>
